let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9PPH7")).then(() => parcelRequire('3OurB'));